<template>
  <div class="app-wrapper">
    <div class="app">
      <NavB v-if="!navigation" />
      <router-view />
      <Footer v-if="!navigation" />
    </div>
  </div>
</template>

<script>
import NavB from "../components/NavB";
import Footer from "../components/footer.vue";
import firebase from "firebase/app";
import "firebase/auth";
export default {
  name: "app",
  components: { NavB, Footer },
  data() {
    return {
      navigation: null,
    };
  },
  created() {
    this.checkRoute();
    firebase.auth().onAuthStateChanged((user) => {
      this.$store.commit("updateUser", user);
      if(user){
        this.$store.dispatch("getCurrentUser")
        console.log(this.$store.state.profileEmail)
      }
    });
  },
  mounted() {},
  methods: {
    checkRoute() {
      if (
        this.$route.name === "Login" ||
        this.$route.name === "Register" ||
        this.$route.name === "ForgotPassword"
      ) {
        this.navigation = true;
        return;
      } else {
        this.navigation = false;
      }
    },
  },
  watch: {
    $route() {
      this.checkRoute();
    },
  },
};
</script>

<style lang="scss">
@import url("https://fonts.googleapis.com/css2?family=Tajawal&display=swap");

* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
  font-family: "Tajawal", sans-serif;
 
}

.app {
  display: flex;
  flex-direction: column;
  min-height: 100vh;
   direction: rtl;
}

.container {
  max-width: 1440px;
  margin: 0 auto;
}

.link {
  cursor: pointer;
  text-decoration: none;
  text-transform: uppercase;
  color: black;
}

.link-light {
  color: #fff;
}

.arrow {
  margin-right: 8px;
  width: 25px;

  path {
    fill: #000;
  }
}
.arrow-light {
  path {
    fill: #fff;
  }
}
.blog__card__wrap {
  position: relative;
  padding: 80px 16px;
  background-color: #f1f1f1;
  @media (min-width: 500px) {
    padding: 100px 16px;
  }
  .blog__cards {
    display: grid;
    gap: 32px;
    grid-template-columns: 1fr;
    @media (min-width: 500px) {
      grid-template-columns: repeat(2, 1fr);
    }
    @media (min-width: 900px) {
      grid-template-columns: repeat(3, 1fr);
    }
    @media (min-width: 1200px) {
      grid-template-columns: repeat(4, 1fr);
    }
  }
}
.error {
  text-align: center;
  color: red;
  font-size: 15px;
}
/* width */
::-webkit-scrollbar {
  width: 9px;
}

/* Track */
::-webkit-scrollbar-track {
  background:transparent;
}

/* Handle */
::-webkit-scrollbar-thumb {
  background: #303030;
  border-radius:30px;
}

/* Handle on hover */
::-webkit-scrollbar-thumb:hover {
  background: #3d3d3d;
}
</style>
